import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * "/" is the real homepage now (decision d15, 2026-09-01): it redirects to
 * /welcome, the 1-Slideshow layout, exactly like /home does. The internal
 * redesign-pitch demo that used to live here moved to /pitch and stays
 * reachable for reference.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/welcome", replace: true });
  },
});
